export default __webpack_public_path__ + "static/media/Women_Sizing _Guide-Mobile.2cf9a9e6.png";